import { useContext } from 'react';
import { LogContext } from './context';
import type { LogContextValue } from './types';

export const useLog = (): LogContextValue => {
  const ctx = useContext(LogContext);
  if (!ctx) throw new Error('useLog must be used within LogProvider');
  return ctx;
};
